export default {
  root: {
    backgroundColor: 'rgb(255 255 255 / 10%)',
    margin: '0 16px',
  },
};
